export default __webpack_public_path__ + "static/media/logo-black.1b5aa170.png";